export const categories = [
  { id: 'all', name: 'All Work' },
  { id: 'equine', name: 'Equine' },
  { id: 'black-background', name: 'Black Background Equine' },
  { id: 'couples', name: 'Couples' },
  { id: 'weddings', name: 'Weddings' },
  { id: 'family', name: 'Family' },
  { id: 'senior', name: 'Senior' },
  { id: 'prom', name: 'Prom' },
  { id: 'pets', name: 'Pets' }
];